import React from "react";

import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";

const FooterCard8 = () => {
  return (<>
    <footer className="imm-footer">
      <div className="imm-footer-container">

        {/* LEFT SECTION */}
        <div className="imm-footer-left">
          <h2 className="imm-logo">IMMIGRAGO</h2>

          <p className="imm-desc">
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
            Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.
          </p>

          <div className="imm-contact-item">📞 123-456-7890</div>
          <div className="imm-contact-item">✉️ immigrago.com</div>

          <div className="imm-social-row"> <h4>Join Us </h4>
            <div className="imm-social-box"><FaFacebookF />
                        </div>
            <div className="imm-social-box"><FaTwitter />
                        </div>
            <div className="imm-social-box"><FaInstagram />
                        </div>
            <div className="imm-social-box"><FaLinkedinIn />
                       </div>
          </div>
        </div>

        {/* MIDDLE SECTION */}
        <div className="imm-footer-mid">
          <h3>OUR SERVICES</h3>
          <ul>
            <li>Solutions</li>
            <li>Meet Our Team</li>
            <li>Blogs</li>
            <li>Testimonials</li>
            <li>Outsourcing</li>
            <li>Privacy Policy</li>
          </ul>

          <button className="imm-buy-btn">Buy Now</button>
        </div>

        {/* RIGHT SECTION */}
        <div className="imm-footer-right">
          <h3>WANT FAST UPDATES FROM US</h3>

          <p className="imm-small">
            Join our WhatsApp community  
          </p>

          <input 
            type="text" 
            placeholder="Enter your mobile number"
            className="imm-input"
          />

          <button className="imm-send-btn">→</button>
        </div>
      </div>
    </footer>
    <style>{`.imm-footer { margin-top:50px;
  background: #082b55;
  color: white;
  
  font-family: "Poppins", sans-serif;
}

.imm-footer-container {
 
  
  display: flex;
  justify-content: space-between;
  gap: 50px;
}

/* LEFT SECTION */
.imm-footer-left {margin: auto;
  width: 33%;padding: 70px 0;
}.imm-footer-mid {
  padding: 70px 0;
}

.imm-logo {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 20px;
}

.imm-desc {
  line-height: 1.6;
  margin-bottom: 20px;
}

.imm-contact-item {
  margin-bottom: 10px;
}

.imm-social-row {
  display: flex;justify-content:center;
  gap: 12px;
  margin-top: 20px;
}

.imm-social-box {
  width: 38px;
  height: 38px;
  background: white;
  color: #082b55;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
}

/* MIDDLE SECTION */
.imm-footer-mid h3 {
  font-size: 20px;
  margin-bottom: 20px;
}

.imm-footer-mid ul {
  list-style: none;
  padding: 0;
}

.imm-footer-mid ul li {
  margin: 8px 0;
  cursor: pointer;
  opacity: 0.9;
}

.imm-buy-btn {
  margin-top: 20px;
  background: rgba(144, 202, 249,1);
  color: #082b55;
  border: none;
  padding: 10px 22px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 600;
}

/* RIGHT SECTION */
.imm-footer-right {padding: 70px 20px;
  width: 33%;  background: rgba(144, 202, 249,1);
}

.imm-footer-right h3 {
  font-size: 22px;
  margin-bottom: 15px;
}

.imm-small {
  opacity: 0.9;
  margin-bottom: 20px;
}

.imm-input {
  width: 80%;
  padding: 10px;
  border-radius: 5px;
  border: none;
}

.imm-send-btn {
  padding: 10px 18px;
  margin-left: 10px;
  background: #082b55;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  color: #ffffff;
}

/* RESPONSIVE */
@media (max-width: 900px) {
  .imm-footer-container {
    flex-direction: column;
    text-align: center;
  }

  .imm-footer-left,
  .imm-footer-mid,
  .imm-footer-right {
    width: 100%;
  }

  .imm-input {
    width: 100%;
    margin-bottom: 10px;
  }
}
`}</style>
  </>);
};

export default FooterCard8;
